module.exports = __webpack_public_path__ + "img/logo.1c36a548.svg";